import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { hideModal, setRuntimeVariable } from '../../../../actions/runtime';
import Button, { ButtonVariations } from '../../../SolvPatternLibrary/Button';
import { colors } from '../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../constants/text';
import { smallerThanOrEqualTo } from '../../../../core/util/styledComponents';
import { formatLocationName, isTelemedLocation } from '../../../../core/util/location';

const StyledButton = styled(Button).withConfig({ componentId: 'sc-ry59am-0' })`
  display: block;
  margin: 16px auto 0;
  ${smallerThanOrEqualTo.sm`
    margin: 0 30px 20px;
  `}
`;

const Root = styled.div.withConfig({ componentId: 'sc-ry59am-1' })`
  height: 428px;
  width: 460px;
  ${smallerThanOrEqualTo.sm`
    height: 100%;
    width: 100%;
  `}
`;

const Text = styled.div.withConfig({ componentId: 'sc-ry59am-2' })`
  color: ${colors.mrGray};
  line-height: 26px;
  width: 323px;
  ${smallerThanOrEqualTo.sm`
    width: 80%;
    margin: 10%;
  `};
  font-size: ${fontSize.default};
  margin: 20px 68px 0;
  text-align: center;
`;

const Title = styled.div.withConfig({ componentId: 'sc-ry59am-3' })`
  color: ${colors.squid};
  width: 300px;
  margin: 0 84px;
  font-size: ${fontSize.damnLarge};
  line-height: 39px;
  text-align: center;
  font-family: ${fontFamily.bold};
  ${smallerThanOrEqualTo.sm`
    width: 80%;
    margin: 10%;
    margin-top: 10px;
  `};
`;

const Close = styled.div.withConfig({ componentId: 'sc-ry59am-4' })`
  width: 25px;
  height: 25px;
  position: relative;
  cursor: pointer;
  margin: 15px 15px 0 auto;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.squid};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.squid};
  }
`;

const ButtonContainer = styled.div.withConfig({ componentId: 'sc-ry59am-5' })`
  display: flex;
  flex-direction: column;
`;

export const TWILIO_MODAL_ID = 'twilioModal';

type Props = {
  setIgnoreTwilioCheck?: (...args: any[]) => any;
  closeModal?: (...args: any[]) => any;
  open?: boolean;
  location?: any;
};

const TwilioModal = ({ open, closeModal, setIgnoreTwilioCheck, location }: Props) => {
  const locationName = formatLocationName(location);
  const text = isTelemedLocation(location)
    ? `${locationName} requires a phone that can receive text messages for video visits`
    : 'Please double check the phone number you entered. For the best experience, use a number that can receive text messages.';
  return (
    // @ts-expect-error ts-migrate(2769) FIXME: Property 'tapOutsideToClose' does not exist on typ... Remove this comment to see the full error message
    <Dialog id={TWILIO_MODAL_ID} open={!!open} tapOutsideToClose={false}>
      <Root>
        <Close onClick={closeModal} />

        <Title>This doesn't look like a real phone number.</Title>

        <Text>{text}</Text>

        <ButtonContainer>
          <StyledButton
            onClick={closeModal}
            text="Update Number"
            variation={ButtonVariations.bluePrimary}
            width={100}
          />

          <StyledButton
            onClick={setIgnoreTwilioCheck}
            text="Proceed anyway"
            variation={ButtonVariations.tertiary}
            width={100}
          />
        </ButtonContainer>
      </Root>
    </Dialog>
  );
};

export default connect(
  (state: any) => ({
    open: state.runtime.modal && !!state.runtime.modal[TWILIO_MODAL_ID],
    location: state.location,
  }),
  (dispatch: any, ownProps: any) => ({
    closeModal: () => dispatch(hideModal(TWILIO_MODAL_ID)),
    setIgnoreTwilioCheck: () => {
      dispatch(hideModal(TWILIO_MODAL_ID));
      ownProps.reSubmitBooking(null, true);
    },
  })
)(TwilioModal);
